export const SET_CHART3_VALUES = "SET_CHART3_VALUES";
export const SET_CHART4_VALUES = "SET_CHART4_VALUES";
export const SET_CHART5_VALUES = "SET_CHART5_VALUES";
export const SET_CHART6_VALUES = "SET_CHART6_VALUES";
